import { CloseCircleOutlined } from '@ant-design/icons';
import classes from './Viewer.module.scss';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hook';
import { setDocsSegment } from 'store/slices/windowStateSlice';

type ErrorType = {
  msg: string;
  onClose?: () => void;
  getFile?: () => Promise<void>
};

const Error = ({ msg, onClose, getFile }: ErrorType) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const rerequestFile = () => {
    getFile && getFile()
  }
  
  return <div className={classes.error} onClick={onClose}>
      {onClose && <CloseCircleOutlined className={classes.close} onClick={onClose} />}
      <div style={{paddingBottom: 20}}>{msg}</div>
      {<Button type='primary' onClick={rerequestFile}>
        {t('Documents.details.rerequest')}
      </Button>}
    </div>;
};

export default Error;
